import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.user.DOC}
  query Users($ids: [ID!], $quantity: Int, $cursor: String) {
    users(ids: $ids, quantity: $quantity, cursor: $cursor) {
      items {
        ...FragmentUser
      }
      nextCursor
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UsersQuery,
    ents.core.common.Response.For.Pagination<models.User>,
    'users'
  >(
    'users',
    graphql.transformers.OUT.object({
      items: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(fragments.user.TRANSFORMER, {
          onNullish: 'remove',
        }),
        [],
      ),
      nextCursor: graphql.transformers.OUT.nullable(transformers.PASS_THROUGH),
    }),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.UsersQuery,
  ents.core.common.Response.For.Pagination<models.User>,
  graphql.schema.UsersQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
